<template>
  <hi-form :initial-values="initialValues" @submit="submit">
    <div class="my-4 font-bold">After Hours Greeting Setting</div>
    <hi-form-item label="Greeting">
      <hi-textarea form-key="greeting" />
    </hi-form-item>
  </hi-form>
</template>

<script>
import HiForm from "@/hive-vue3/components/form/HiForm";
import HiFormItem from "@/hive-vue3/components/form/HiFormItem";
import HiTextarea from "@/hive-vue3/components/form/controls/HiTextarea";
import { firestoreDoc, updateFirestoreDoc } from "@/hive-vue3/firebase";
import { twilioState } from "@/hive-vue3/modules/twilio/state";
export default {
  name: "TwilioAfterHoursGreetingEditor",
  components: { HiTextarea, HiFormItem, HiForm },
  props: {
    initialValues: Object,
  },
  setup() {
    async function submit(data) {
      await updateFirestoreDoc(firestoreDoc("phone", "settings"), {
        [twilioState.currentNumber]: {
          greetings: {
            afterHours: data,
          },
        },
      });
    }
    return {
      submit,
    };
  },
};
</script>

<style scoped></style>
